"use client";
import { useState } from "react";
import { Section } from "../ui/Section";
import { Typography } from "../ui";
import { env } from "@/lib/environment";
import Image from "next/image";
import { cn } from "@/lib/utils";

export default function SecurityCertifications() {
  const [selectedItem, setSelectedItem] = useState(0);

  const certifications = [
    {
      title: "SOC2 Certification",
      icon:
        env.NEXT_PUBLIC_CDN_URL +
        "/images/digital-signage-security/soc-loogo-smal.mFmARo_N40Zl.png",
      image:
        env.NEXT_PUBLIC_CDN_URL +
        "/images/digital-signage-security/soc-logo-images.mBuUC_GwioBf.png",
      alt: "SOC2 Certification",
      description:
        "The SOC 2 certification proves our commitment to strong digital signage security. Here’s how we ensure it:",
      points: [
        "Strong protection against unauthorized physical and digital access.",
        "Reliable system uptime, as promised.",
        "Accurate, timely, and authorized transaction processing.",
        "Careful handling of personal data, following our privacy policy.",
      ],
    },
    {
      title: "ISO 27001 Certification",
      icon:
        env.NEXT_PUBLIC_CDN_URL +
        "/images/digital-signage-security/frame-iso-small.R0XY0Q9la4IZ.png",
      image:
        env.NEXT_PUBLIC_CDN_URL + "/images/digital-signage-security/iso-images.rc4GQZBzHfXj.png",
      alt: "ISO 27001 Certification",
      description:
        "Our ISO 27001 certification proves we have a strong security system to protect your data. This includes:",
      points: [
        "Our ISMS provides a detailed framework to manage security risks",
        "Regular checks to keep our system up-to-date with threats.",
        "Security that meets high industry benchmarks.",
      ],
    },
  ];
  return (
    <Section
      variant="default"
      className="bg-gray-50"
    >
      <div className="mb-16 max-w-2xl mx-auto">
        <Typography variant="h2" as="h2" className="text-center">
          Industry-Leading Digital Signage Security Certifications
        </Typography>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="flex flex-col gap-2">
          {certifications.map((certification, index) => (
            <div
              key={index}
              className={cn(
                "flex items-center gap-4 cursor-pointer p-4 rounded-2xl max-w-[500px]",
                selectedItem === index && "bg-secondary/5"
              )}
              onClick={() => setSelectedItem(index)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setSelectedItem(index);
                }
              }}
              role="button"
              tabIndex={0}
            >
              <Image src={certification.icon} alt={certification.alt} title={certification.alt} width={60} height={60} />
              <Typography variant="h3" as="h3" >
                {certification.title}
              </Typography>
            </div>
          ))}
        </div>
        <div className="flex flex-col gap-2 rounded-2xl bg-white p-6 border border-gray-200">
         <div className="flex items-center gap-4 mb-4 bg-gray-50 p-6 rounded-2xl">
         <Image
            src={certifications[selectedItem].image}
            alt={certifications[selectedItem].alt}
            title={certifications[selectedItem].alt}
            width={150}
            height={150}
          />
         <div>
         <Typography variant="h3" as="h3">
            {certifications[selectedItem].title}
          </Typography>
          <Typography variant="body" as="p">
            {certifications[selectedItem].description}
          </Typography>
         </div>
         </div>
          <ul className="list-disc pl-6 mt-4">
            {certifications[selectedItem].points.map((point, index) => (
              <li key={index} className="mb-1">{point}</li>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  );
}
